import React from 'react';
import './DateAndTime.css';


let today = new Date();
class Time extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			hours: String(today.getHours()).padStart(2, '0'),
			minutes: String(today.getMinutes()).padStart(2, '0'),
			seconds: String(today.getSeconds()).padStart(2, '0'),
			hours12: String(this.checkOver12(today.getHours())).padStart(2, '0'),
		}

	}

	componentDidMount() {
	    this.intervalID = setInterval(() => this.clock(), 1000);

	}

 	componentWillUnmount() {
    	clearInterval(this.intervalID);
 	 }

 	checkOver12(num) {
 		if (num > 12) {
 			return num = num - 12;
 		} else {
 			return num;
 		}
 	}

	clock() {
		let newTime = new Date();
			this.setState({
			hours: String(newTime.getHours()).padStart(2, '0'),
			minutes: String(newTime.getMinutes()).padStart(2, '0'),
			seconds: String(newTime.getSeconds()).padStart(2, '0'),
			hours12: String(this.checkOver12(newTime.getHours())).padStart(2, '0'),	
			})
	  }



	render() {
		return(
			<h1 className='time-container'>
				<div className='time-name'>
					<div className='time-hours'>
						{this.state.hours}
					</div>
					<div className='time-hours-12 show'>
						{this.state.hours12}
					</div>
					<div className='time-minutes'>
						:{this.state.minutes}
					</div>
					<div className='time-seconds'>
						:{this.state.seconds}
					</div>
				</div>
			</h1>
		)
	}
}

export default Time